import { Controller } from "@hotwired/stimulus"

// M41. Shows what a document number will look like AS the format is typed,
// instead of making somebody save and come back to find out. The sequence
// comes from the server (the real next number), so the preview is the actual
// next number rather than a made-up 00001.
export default class extends Controller {
  static targets = ["prefix", "separator", "padding", "yearly", "output"]
  static values = { sequence: Number, year: String, fallback: String }

  connect() {
    this.render()
  }

  render() {
    const prefix = (this.prefixTarget.value || this.prefixTarget.placeholder || "").trim().toUpperCase()
    // An empty prefix means "use the built-in format" — so the preview shows
    // exactly what they will go back to, not a half-built number.
    if (!this.prefixTarget.value.trim()) {
      this.outputTarget.textContent = this.fallbackValue
      this.outputTarget.dataset.state = "default"
      return
    }

    const separator = this.separatorTarget.value
    const padding = parseInt(this.paddingTarget.value, 10) || 5
    const parts = [prefix]
    if (this.yearlyTarget.checked) parts.push(this.yearValue)

    const sequence = String(this.sequenceValue || 1).padStart(padding, "0")
    this.outputTarget.textContent = parts.join(separator) + separator + sequence
    this.outputTarget.dataset.state = "custom"
  }
}
